import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SlotCounterStationPayDistributionSheet from '@/components/Counter/SlotCounterStationPayDistributionSheet';
import dateUtils from '@/utils/dateUtil';
import moment from 'moment';
import { mapGetters } from 'vuex';
export default {
  name: 'StationPayDistribution',
  components: {
    SlotCounterStationPayDistributionSheet: SlotCounterStationPayDistributionSheet
  },
  data: function data() {
    return {
      datePickerValue: dateUtils.todayTimestamp() * 1000 - 86400 * 1000,
      refIndex: 0,
      pickerOptionsLimit: {
        disabledDate: function disabledDate(pTime) {
          return pTime.getTime() < new Date() - 91 * 86400 * 1000 || pTime.getTime() > new Date() - 86400 * 1000;
        }
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('stations', ['asyncStations'])), mapGetters('user', ['userInfo'])),
  created: function created() {},
  methods: {
    monthStart: function monthStart(ts) {
      return moment(new Date(ts)).startOf('month').unix() * 1000;
    },
    monthEnd: function monthEnd(ts) {
      return moment(new Date(ts)).endOf('month').unix() * 1000;
    },
    tabClick: function tabClick(el) {
      this.refIndex += 1;
    }
  }
};